import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import PersonnelTable from "./PersonnelTable";
import usePersonnelTable from "./usePersonnelTable";
import EditContactDialog from "./EditContactDialog";
import API_ROUTES from "../../../api-routes";
import { useDispatch } from "react-redux";
import { fetchPersonnel } from "./personnelSlice";
import apiService from "../../../services/service";
import { useParams } from "react-router-dom";
import SuccessfulOnboarded from "../../../Pages/EntityOnboard/components/SuccessfulOnboarded";
import AuditSidebar from "../../audit-sidebar/AuditSidebar";
import PermissionGate from "~/components/PermissionGate";
import { useEntity } from "../../../Pages/Entities";

const Personnel = ({
  showKeyPersonnel,
  personnelState,
  setPersonnelState,
  isCongrats,
  showHistoryBtn = true,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { entity } = useEntity();

  const {
    editVisible,
    setEditVisible,
    rowToEdit,
    setRowToEdit,
    showAddDialog,
    isAddMode,
    successMessage,
    setSuccessMessage,
  } = usePersonnelTable();

  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAddNewContact = () => {
    showAddDialog();
  };

  const handleSave = async (formData) => {
    setIsLoading(true);
    const personnelData = {
      name: formData.name,
      last_name: formData.last_name,
      preferred_name: formData.preferred_name,
      other_name: formData.other_name,

      role: formData.role,
      email: formData.email,
      phone: formData.phone || "",
      phone_code: formData.phone_code || "",
      country: formData.country || null,
    };

    if (showKeyPersonnel) {
      setPersonnelState((prevState) => {
        const updatedPersonnelData = {
          ...personnelData,
          id: prevState.length,
        };

        return [...prevState, updatedPersonnelData];
      });
      setSuccessMessage("New Key Personnel has been added.");
    } else {
      const apiRoute = isAddMode ? API_ROUTES.ADD_PERSONNEL : "";

      try {
        const res = await apiService(apiRoute, "POST", {
          body: JSON.stringify(personnelData),
          replace: { id },
        });

        if (res.status) {
          dispatch(fetchPersonnel(id));
          setSuccessMessage("New Key Personnel has been added.");
        } else {
          setSuccessMessage("Failed to save contact details");
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error:", error);
        setIsLoading(false);
      }
    }
    setEditVisible(false);
  };

  const auditLabels = () => {
    return {
      create: "Contact Created",
      update: "Contact Updated",
      delete: "Contact Deleted",
    };
  };

  const personnelContent = (
    <>
      {sidebarToggle && (
        <AuditSidebar
          heading="Key Personnel"
          endpoint={API_ROUTES.FETCH_PERSONNEL_AUDIT}
          id={id}
          labels={auditLabels}
          setSidebarToggle={setSidebarToggle}
          sidebarToggle={sidebarToggle}
        />
      )}
      <div className="general-info-container flex justify-content-between formgrid grid grid-nogutter">
        {!showKeyPersonnel ? (
          <div>
            <p className="general-info">Key Personnel</p>
            <p className="general-info-para">
              Contact key personnel directly. Find contact information here.
            </p>
          </div>
        ) : (
          <div>
            <p className="general-info">Key Personnel</p>
          </div>
        )}
        <PermissionGate
          resource="entity"
          action="modify"
          resourceAttr={{
            entity_id: id,
            tenant_id: entity?.tenant_id,
          }}
        >
          <div className="btns-container flex align-items-center">
            {showHistoryBtn && (
              <button
                className="add-new-button mr-2"
                onClick={() => setSidebarToggle(!sidebarToggle)}
              >
                View History
                <span className="pi pi-history mb-1 ml-2" />
              </button>
            )}
            <button className="add-new-contact" onClick={handleAddNewContact}>
              Add New Contact<span className="pi pi-user-plus mb-1 ml-2"></span>
            </button>
          </div>
        </PermissionGate>
      </div>
      <div className="card">
        <PersonnelTable
          onAddContactClick={handleAddNewContact}
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
          showKeyPersonnel={showKeyPersonnel}
          personnelState={personnelState}
          setPersonnelState={setPersonnelState}
        />
      </div>
    </>
  );

  useEffect(() => {
    if (personnelState) setPersonnelState(personnelState);
  }, [personnelState]);

  return (
    <div className="personnel-container">
      {!isCongrats ? (
        !showKeyPersonnel ? (
          <Card className="gen-card h-full">{personnelContent}</Card>
        ) : (
          personnelContent
        )
      ) : (
        <SuccessfulOnboarded />
      )}
      <EditContactDialog
        visible={editVisible}
        onHide={() => setEditVisible(false)}
        rowToEdit={rowToEdit}
        setRowToEdit={setRowToEdit}
        onSave={handleSave}
        isAddMode={isAddMode}
        isLoading={isLoading}
      />
    </div>
  );
};

export default Personnel;
